export default {
	mounted: function() {
		if(this.$refs.container)
			this.$refs.container.style.minHeight = (window.innerHeight-224)+"px";
	},
}